import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { actions } from './store/actions'
import { getProfile, getProfileLoading } from './store/reducers'
import ProfileForm from './ProfileForm'
import Spin from 'components/ui/Spin'

class ProfileContainer extends React.Component {

  constructor() {
    super()
    this.fetchProfile = this.fetchProfile.bind(this)
  }

  componentWillMount() {
    this.fetchProfile()
  }

  fetchProfile() {
    const { actions } = this.props
    actions.fetch()
  }

  render() {
    const { handleSubmit, loading } = this.props

    if (loading) {
      return <Spin />
    } else {
      return (
        <div className="imProfile">
          <h1 className="imProfile__title">My Profile</h1>
          <div className="imProfile__form">
            <ProfileForm onSubmit={handleSubmit} />
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = state => ({
  contact: getProfile(state),
  loading: getProfileLoading(state)
})

const mapDispatchToProps = (dispatch) => {
  const { fetch, update } = actions
  return {
    handleSubmit: (values) => {
      dispatch(update(values))
    },
    actions: bindActionCreators({fetch}, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileContainer)



// WEBPACK FOOTER //
// ./src/features/Settings/profile/ProfileContainer.jsx